import { Z_INDEX_SOURCE } from './enum/PositionEnum';
import { NO_PATTERN, NO_URL } from './enum/ModelEnum';

export const YES_ELF_HOLDER_TAG = 'yes-elf-holder';
export const PROGRESS_TRACKER_HOLDER_CLASS = 'progress-tracker-holder';
export const EDITOR_HOLDER_TAG = 'editor-holder';
export const YES_ELF_LAUNCHER_BAR_ID = 'yeself-launcher-bar';
export const YES_ELF_BODY_HOLDER_ID = 'yeself-body';
export const YES_ELF_LOGGER_HOLDER_ID = 'yeself-logger';
export const YES_ELF_AUGMENTATION_HOLDER_ID = 'yeself-augmentation';
export const CONTEXT_HELP_HOLDER_CLASS = 'context-help-holder';
export const EDITOR_HOLDER_IFRAME_ID = 'adopt-editor-holder-iframe';

/**
 * Contains constants related to data model.
 */

export const INITIAL_NODE_NAME = 'initial';
export const FINISH_NODE_NAME = 'virtual-finish';
export const SUSPEND_NODE_NAME = 'suspend';
export const DECISION_NODE_NAME = 'decision';
export const NODE_VIRTUAL_PREFIX = 'virtual';

export const NODE = {
    ACTION: 'action',
    INITIAL: INITIAL_NODE_NAME,
    WAIT_COMMAND: 'virtual-wait-command',
    WAIT_KICK: 'virtual-wait-kick',
    WAIT_NO_GUIDE_RUNNING: 'virtual-wait-no-guide-running',
    WAIT_COMPLETION: 'virtual-wait-completion',
    WAIT_STEP_TRANSITION_END: 'virtual-wait-transitionStepEnd',
    WAIT_ELEMENT_TRANSITION_END: 'virtual-wait-transitionElementEnd',
    STEP: 'step',
    VIRTUAL_STEP: 'virtual-step',
    FINISH: FINISH_NODE_NAME,
    SUSPEND: SUSPEND_NODE_NAME,
    DECISION: DECISION_NODE_NAME,
};

/**
 * @deprecated use TOUR_NODE_TYPE
 */
export const NODE_TYPE = {
    ACTION: 'action',
    STEP: 'step',
    DECISION: 'decision',
};

/**
 * @deprecated use enum/TourEnum.ts
 */
export const ACTION_TYPE = {
    CLICK: 'click',
    FOCUS: 'focus',
};

/**
 * @deprecated use enum/ModelEnum.ts
 */
export const EVENT_OPERAND = {
    AND: 'and',
    OR: 'or',
    EVENT: 'event',
};

/**
 * @deprecated use ModelEnum
 */
export const DECISION_CONDITION_TYPE = {
    ELEMENT_PRESENT: 'elementPresent',
    ELEMENT_VISIBLE: 'elementVisible',
};

/**
 * @deprecated use ModelEnum
 */
export const EVENT_VALUES = {
    PRESENT: 'present',
    NOT_PRESENT: 'not_present',
    VISIBLE: 'visible',
    NOT_VISIBLE: 'not_visible',
    CLICK: 'click',
    SPOT_VIEWPORT: 'spot_viewport',
    MOUSE_UP: 'mouseup',
    MOUSE_DOWN: 'mousedown',
    MOUSE_OVER: 'mouseenter',
    CHANGE: 'change',
    LEAVE_ATTENTION: 'leave_attention',
    TIMEOUT: 'timeout',
    COMMAND: 'command',
    BLUR: 'blur',
};

export const EVENT_TARGET = {
    ELEMENT: 'ELEMENT',
    WINDOW: 'WINDOW',
    DOCUMENT: 'DOCUMENT',
    NONE: 'NONE',
};

/**
 * (!) Must be synchronized with guide model.
 *
 * @see /schema/yeself-guide-server/guide.schema.json#/definitions/edge
 * @deprecated use ModelEnum
 */
export const KICK = {
    TIMEOUT: 'timeout',
    EVENT: 'event',
    COMMAND: 'command',
    SYSTEM_COMMAND: 'system_command',
};
/**
 * @deprecated use ModelEnum
 */
export const KICK_EVENT_VALUES = {
    PRESENT: EVENT_VALUES.PRESENT,
    NOT_PRESENT: EVENT_VALUES.NOT_PRESENT,
    VISIBLE: EVENT_VALUES.VISIBLE,
    NOT_VISIBLE: EVENT_VALUES.NOT_VISIBLE,
    SPOT_VIEWPORT: EVENT_VALUES.SPOT_VIEWPORT,
    MOUSE_UP: EVENT_VALUES.MOUSE_UP,
    MOUSE_OVER: EVENT_VALUES.MOUSE_OVER,
    BLUR: EVENT_VALUES.BLUR,
    CHANGE: EVENT_VALUES.CHANGE,
    LEAVE_ATTENTION: EVENT_VALUES.LEAVE_ATTENTION,
};

export const EVENT_EFFECT_PREFIX = 'yeself-effect-';

export const EVENT_EFFECTS = {
    NONE: `${EVENT_EFFECT_PREFIX}none`,
    RIPPLE: `${EVENT_EFFECT_PREFIX}ripple`,
};

/**
 * (!) Must be synchronized with guide model.
 *
 * @see /schema/yeself-guide-server/guide.schema.json#/definitions/edge
 * @deprecated use ModelEnum
 */
export const COMPLETION = {
    NEXT: 'next',
    PREVIOUS: 'previous',
    TIMEOUT: 'timeout',
    EVENT: 'event',
    NAVIGATION: 'navigation',
    MOUNTED: 'mounted',
    LOADED: 'loaded',
    COMMAND: 'command',
    RENDER: 'render',
    DECISION_TRUE: 'decision-true',
    DECISION_FALSE: 'decision-false',
};

/**
 * @deprecated use ModelEnum
 */
export const COMPLETION_EVENT_VALUES = {
    MOUSE_UP: EVENT_VALUES.MOUSE_UP,
    MOUSE_DOWN: EVENT_VALUES.MOUSE_DOWN,
    MOUSE_OVER: EVENT_VALUES.MOUSE_OVER,
    BLUR: EVENT_VALUES.BLUR,
    CHANGE: EVENT_VALUES.CHANGE,
    PRESENT: EVENT_VALUES.PRESENT,
};

export const COMPLETION_NAVIGATION_VALUES = {
    /** When no navigation occurs. */
    NO: 'no',
    /** When such window location change occurs that does NOT cause page REFRESH (only hash part of URL changes) */
    SOFT: 'soft',
    /** When such window location change occurs that CAUSES page to REFRESH (different than hash part changed) */
    HARD: 'hard',
    WAIT: 'wait',
};

export const EDGE_CONSTRAINTS = {
    ELEMENT_PRESENT: 'isElementPresent',
    URL_EQUAL: 'isUrlEqual',
    COMMAND_VALUE: 'commandValue',
};

export const ASPECT = {
    RESET: 'reset',
    CLOSE: 'close',
    JUMP_TO: 'jump_to',
    SUSPEND: 'suspend',
    RESUME: 'resume',
    PREVIOUS: 'previous',
};

export const COMMAND = {
    START: 'start',
    CONTEXT_HELP_START: 'context_help_start',
    JOURNEY_TRACKER_START: 'journey_tracker_start',
    NEXT: 'next',
    PREVIOUS: 'previous',
    USER_PROFILE_UPDATED: 'user_profile_updated',
    NO_GUIDE_RUNNING: 'no_guide_running',
};

// Private = for internal sharing between agent & editor

export const NO_LOCATION = {
    url: 'http://no-url-here.com/',
    paths: [],
};

/**
 * @deprecated use enum/RuleEnum.ts
 */
export const RULES_ASSIGNMENT_TYPE = {
    JOURNEY_TRACKER: 'journeyTracker',
    CONTEXT_HELP: 'contextHelp',
};

/**
 * @deprecated use enum/RuleEnum.ts
 */
export const RULES_ASSIGNMENT_FORM = {
    INVISIBLE: 'invisible',
    DISABLED: 'disabled',
};

/**
 * @deprecated use enum/RuleEnum.ts
 */
export const RULE_LEVEL_TYPE = {
    OPTION: 'option',
    NUMBER: 'number',
    TEXT: 'text',
    PATTERN: 'pattern',
    DATE: 'date',
};

export const RULE_LEVEL_SOURCE = {
    GUIDE_LIST: 'GUIDE_LIST',
    GUIDE_STEP_LIST: 'GUIDE_STEP_LIST',
    SEGMENT_LIST: 'SEGMENT_LIST',
};

export const TRIGGER_TYPE = {
    DOM: 'dom',
    VISIT: 'visit',
    CONFUSION_ACCEPT: 'cf_accept',
    CONFUSION_REJECT: 'cf_reject',
    GUIDE_TARGETED: 'guide_targeted',
};

export const GUIDE_TARGET_SOURCE = {
    AUTO_START: 'auto_start',
    CONTEXT_HELP: 'context_help',
    JOURNEY_TRACKER: 'journey_tracker',
    PERSISTENCE: 'persistence',
};

export const DEFAULT_CONTENT_LANGUAGE = 'en';
export const DEFAULT_USED_LOCALE = {
    code: DEFAULT_CONTENT_LANGUAGE,
    label: 'English',
};

/**
 * @type {Rect}
 */
export const DEFAULT_ELEMENT_PADDING = {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
};

export const ELEMENT_PATHS = {
    RELATIVE: 'relative',
    RELATIVE_LIMITED: 'relativeLimited',
    EXPRESSED: 'expressed',
    CLASS_ONLY: 'classOnly',
    XPATH: 'xpath',
    XPATH_LIMITED: 'xpathLimited',
    TAG_ONLY: 'tagOnly',
    JS_PATH: 'jsPath',
    JS_PATH_NON_RELATIVE: 'jsPathNonRelative',
};

export const ELEMENT_PATH_ORDER = [
    ELEMENT_PATHS.XPATH,
    ELEMENT_PATHS.RELATIVE,
    ELEMENT_PATHS.XPATH_LIMITED,
    ELEMENT_PATHS.RELATIVE_LIMITED,
    ELEMENT_PATHS.EXPRESSED,
    ELEMENT_PATHS.CLASS_ONLY,
    ELEMENT_PATHS.TAG_ONLY,
    ELEMENT_PATHS.JS_PATH,
];

export const PATH = {
    NOT_RECORDED_YET: 'NOT_RECORDED_YET',
    NOT_VALID: 'NOT_VALID',
    VALID: 'VALID',
};

export const LANGUAGE_READ = {
    BROWSER: 'browser',
    APPLICATION: 'application',
};

export const AGENT_LANGUAGE_AUTO = 'auto';

export const TARGET_RESOLVE = {
    STEP: 'resolve-step-',
    COMPLETION: 'resolve-completion-',
    KICK_OR_STEP: 'resolve-kick-or-step-',
    KICK_OR_STEP_OR_DECISION: 'resolve-kick-or-step-or-decision',
    SYSTEM_COMMAND_OR_KICK_OR_STEP: 'resolve-system_command-or-kick-or-step-',
};

export const IMPORT_TRANSLATION_ERROR = {
    GUIDE_NOT_FOUND: 'guideNotFound',
    STEP_NOT_FOUND: 'stepnotFound',
    LANGUAGE_NOT_FOUND: 'languageNotFound',
    INCORRECT_HEADER_IN_CSV: 'incorrectHeaderInCsv',
    UNSUPPORTED_FILETYPE: 'unsupportedFiletype',
};

export const LOCATION_CHANGE_DETECTOR = {
    TIMEOUT: 'TIMEOUT',
    HISTORY: 'HISTORY',
};

/**
 * @deprecated use NO_URL or NO_PATTERN from ModelEnum
 */
export const LOCATION_HREF = {
    NO_PATTERN,
    NO_URL,
};

export const NO_EVENT_VALUE = 'NO_EVENT_VALUE';

export const GUIDE_PROGRESS_FINISHED = 'guide-finished';

export const TRANSITION_TYPE = {
    ENTER_INIT: 'ENTER_INIT',
    ENTER: 'ENTER',
    LEAVE_INIT: 'LEAVE_INIT',
    LEAVE: 'LEAVE',
};

/**
 * @deprecated Moved it to typings/guide/LayerEnum
 */
export const ANIMATION_TYPE = {
    NO: 'NO',
    FADE: 'FADE',
    ZOOM: 'ZOOM',
    TRANSITION: 'TRANSITION',
};

export const STEP_ANIMATION_TYPE = {
    NO: ANIMATION_TYPE.NO,
    FADE: ANIMATION_TYPE.FADE,
    ZOOM: ANIMATION_TYPE.ZOOM,
};

/**
 * @deprecated Moved it to typings/guide/tour/TourEnum
 */
export const SHADOW_ANIMATION_TYPE = {
    NO: ANIMATION_TYPE.NO,
    TRANSITION: ANIMATION_TYPE.TRANSITION,
};

export const BORDER_ANIMATION_TYPE = {
    NO: ANIMATION_TYPE.NO,
    TRANSITION: ANIMATION_TYPE.TRANSITION,
};

export const ELEMENT_ANIMATION_TYPE = {
    NO: 'NO',
    ZOOM: 'ZOOM',
};

/**
 * @deprecated Move it to typings/guide/tour/TourEnum
 */
export const SHADOW_TYPE = {
    NO: 'NO',
    TRANSPARENT: 'TRANSPARENT',
    BLUR: 'BLUR',
};

/**
 * @deprecated Move it to typings/guide/tour/TourEnum
 */
export const BORDER_TYPE = {
    NO: 'NO',
    SOLID: 'SOLID',
    GRADIENT: 'GRADIENT',
};

export const SOUND_STATE = {
    NO_SOUND: 'sound_no',
    PLAYING: 'sound_playing',
    PAUSED: 'sound_paused',
    ENDED: 'sound_ended',
};

/**
 * @deprecated use typings/guide/tour/TourEnum
 */
export const PREVENT_INTERACTION_TYPE = {
    OFF: 'off',
    GLOBAL: 'global',
    SURROUNDING: 'surrounding',
};

export const NO_USER = 'no-user-yet';
export const NO_VISITOR = 'no-visitor-yet';
export const NO_TRACKER = 'no-tracker-yet';

export const GUIDE_TYPE = {
    TOUR: 'tour',
    INTERACTION_COLLECTOR: 'c-overlay',
    ERROR_COLLECTOR: 'e-overlay',
    APPLICATION_AUGMENTATION: 'a-overlay',
    RECORDING: 'recording',
};

export const GUIDE_SUB_TYPE = {
    PLAYLIST: 'playlist',
} as const;

export const QUERY_EDITOR_PARAM = {
    TOURID: 'ye-edit-tour',
    COLLECTORID: 'ye-edit-collector',
    APPLICATION_AUGMENTATION_ID: 'ye-edit-application-augmentation',
    LANG: 'ye-lang',
    PREVIEW: 'yeself-preview',
};

export const LOCAL_STORAGE_EDITOR_PARAM = {
    GUIDEID: 'yeself-editor-guideId',
    INTERACTION_COLLECTOR_ACTIVE: 'yeself-c-overlay-editor-active',
    TOUR_ACTIVE: 'yeself-tour-editor-active',
    APPLICATION_AUGMENTATION_ACTIVE: 'yeself-a-overlay-editor-active',
};

export const DEFAULT_ELEMENT_ZOOM_STRENGTH = 1.2;

export const CONTEXT_HELP_CHECKLIST = {
    PROGRESS: 'PROGRESS',
    JOURNEY: 'JOURNEY',
};

export const STEP_Z_INDEX_OPTIONS = Z_INDEX_SOURCE;
